import type { CSSObject } from "@mui/material/styles";

/** A fade-and-rise entrance on an ease-out curve; plays once and is off for reduced motion. */
export function riseIn(seconds: number, delaySeconds = 0): CSSObject {
  return {
    "@keyframes rcAuthRise": {
      from: { opacity: 0, transform: "translateY(18px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
    animation: `rcAuthRise ${seconds}s cubic-bezier(0.22, 1, 0.36, 1) ${delaySeconds}s both`,
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  };
}
